<template>
    <div class="briefcase_main_wrp">
        <div class="briefcase_main_list">
            <!-- Briefcase Header Start -->
            <div class="briefcase_main_header">
                <!-- Default Toolbar -->
                <div class="first_step_for_folder" v-if="firstStepOfToolbarState && !selectedFolderForFirstStep">
                    <div class="d-flex align-items-center justify-content-between w-100">
                        <!-- Left Action Icons -->
                        <div class="header_left_actions">
                            <ul class="list_icon action_list_icon">
                                <li>
                                    <button type="button" class="icon_btn" title="Folder Upload"
                                        @click.stop="selectedOptionForNewBriefcaseMethod('uploadFolders')"
                                        :class="{ active: foldersUploadState }">
                                        <img src="@/assets/images/upload_folder_icon.png" alt="Upload Folder"
                                            class="img-fluid" width="18" />
                                    </button>
                                </li>
                                <li>
                                    <button type="button" class="icon_btn" title="New Folder"
                                        @click.stop="selectedOptionForNewBriefcaseMethod('newFolder')"
                                        :class="{ active: newFolderState }">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                                            viewBox="0 0 512 511">
                                            <path fill="currentColor"
                                                d="m496.91 49.85h-414.49c-4 0-7.85 1.59-10.68 4.43-2.83 2.83-4.42 6.68-4.41 10.69l.26 151.05c13.07-4.07 26.96-6.27 41.35-6.27 76.71 0 139.12 62.41 139.12 139.11 0 16.71-2.96 32.73-8.39 47.59h257.25c8.33 0 15.09-6.76 15.09-15.09v-316.43c0-8.33-6.76-15.08-15.09-15.08zm-48.29 269.19c0 8.33-6.76 15.09-15.09 15.09h-103.62c-8.34 0-15.09-6.76-15.09-15.09 0-8.34 6.75-15.09 15.09-15.09h103.62c8.34 0 15.09 6.75 15.09 15.09z" />
                                            <path fill="currentColor"
                                                d="m284.79 19.67-1.45-7.09c-1.43-7.03-7.61-12.07-14.79-12.07h-147.75c-7.17 0-13.35 5.04-14.79 12.07l-1.45 7.09z" />
                                            <path fill="currentColor"
                                                d="m217.87 348.87c0-60.07-48.87-108.94-108.94-108.94-60.07 0-108.93 48.87-108.93 108.94 0 60.07 48.86 108.93 108.93 108.93s108.94-48.86 108.94-108.93zm-69.31 15.09h-24.54v24.54c0 8.33-6.75 15.09-15.09 15.09-8.33 0-15.09-6.76-15.09-15.09v-24.54h-24.54c-8.33 0-15.09-6.76-15.09-15.09 0-8.34 6.76-15.09 15.09-15.09h24.54v-24.54c0-8.33 6.76-15.09 15.09-15.09 8.34 0 15.09 6.76 15.09 15.09v24.54h24.54c8.33 0 15.09 6.76 15.09 15.09 0 8.33-6.76 15.09-15.09 15.09z" />
                                        </svg>
                                    </button>
                                </li>
                                <li>
                                    <button type="button" class="icon_btn" title="File Upload"
                                        @click.stop="selectedOptionForNewBriefcaseMethod('uploadFiles')"
                                        :class="{ active: filesUploadState }">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                                            viewBox="0 0 512 512">
                                            <path fill="currentColor" d="m354.78 66.76 53.91.09-53.91-53.91zm0 0" />
                                            <path fill="currentColor"
                                                d="m339.58 97.08c-8.37-.02-15.15-6.8-15.15-15.18v-81.9h-257.41c-8.38 0-15.18 6.79-15.18 15.18v270.46c15.8-6.6 33.13-10.25 51.29-10.25 8.97 0 17.73.89 26.21 2.59-1.01-2.03-1.6-4.32-1.6-6.75 0-8.38 6.79-15.17 15.18-15.17h182.77c8.38 0 15.18 6.79 15.18 15.17 0 8.38-6.8 15.18-15.18 15.18h-169.49c47.27 20.57 80.41 67.71 80.41 122.46 0 21.25-5 41.36-13.88 59.21h184.84c8.38 0 15.18-6.79 15.18-15.18v-355.68zm-68.52 54.77c0 8.38-6.8 15.18-15.18 15.18h-112.96c-8.38 0-15.18-6.8-15.18-15.18 0-8.38 6.8-15.18 15.18-15.18h112.96c8.38 0 15.18 6.8 15.18 15.18zm54.63 74.87h-182.77c-8.38 0-15.18-6.8-15.18-15.18 0-8.38 6.8-15.18 15.18-15.18h182.77c8.38 0 15.18 6.8 15.18 15.18 0 8.38-6.8 15.18-15.18 15.18z" />
                                            <path fill="currentColor"
                                                d="m206.26 408.87c0-56.87-46.26-103.13-103.13-103.13-56.87 0-103.13 46.26-103.13 103.13 0 56.87 46.26 103.13 103.13 103.13 56.87 0 103.13-46.27 103.13-103.13zm-73.45 15.18h-14.5v14.5c0 8.38-6.8 15.18-15.18 15.18-8.38 0-15.18-6.8-15.18-15.18v-14.5h-14.5c-8.38 0-15.18-6.8-15.18-15.18 0-8.38 6.8-15.18 15.18-15.18h14.5v-14.5c0-8.38 6.8-15.18 15.18-15.18 8.38 0 15.18 6.8 15.18 15.18v14.5h14.5c8.38 0 15.18 6.8 15.18 15.18 0 8.38-6.8 15.18-15.18 15.18z" />
                                        </svg>
                                    </button>
                                </li>
                            </ul>
                        </div>

                        <!-- Right Controls: Toggle Shared & Layout View -->
                        <div class="header_right_actions">
                            <div class="d-flex align-items-center">
                                <button type="button" class="btn btn-pill-dark mr-2" v-if="mainBriefcaseListState"
                                    @click="showSharedBriefcaseMethod">
                                    <i class="fa fa-users mr-1" aria-hidden="true"></i> Shared Folders
                                </button>
                                <button type="button" class="btn btn-pill-dark mr-2" v-else
                                    @click="showSharedBriefcaseMethod">
                                    <i class="fa fa-user mr-1" aria-hidden="true"></i> My Folders
                                </button>

                                <!-- Grid / List Switcher Button -->
                                <button type="button" class="icon_btn" @click="gridChangeToListForFirstStepMethod"
                                    :title="gridToList ? 'Switch to Grid View' : 'Switch to List View'">
                                    <i :class="gridToList ? 'fa fa-th' : 'fa fa-th-list'" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Selected Folder Toolbar -->
                <div class="folder_toolbar_wrp" v-if="!firstStepOfToolbarState && selectedFolderForFirstStep">
                    <div class="d-flex align-items-center justify-content-between w-100">
                        <div class="d-flex align-items-center text-truncate">
                            <i class="fa fa-angle-left nav_back_btn" aria-hidden="true"
                                @click="backToFirstStepMethod"></i>
                            <h4 class="mb-0 selected_folder_heading text-truncate" :title="folderToolbarData.name">
                                {{ limitTo(folderToolbarData.name) }}
                            </h4>
                        </div>
                        <ul class="list_icon justify-content-end mb-0">
                            <li
                                v-if="!folderToolbarData.is_folder || (folderToolbarData.sub_folders && folderToolbarData.sub_folders.length > 0)">
                                <button class="icon_btn" @click="showShareBriefcasePopupMethod(folderToolbarData)"
                                    title="Share">
                                    <i class="fa fa-share-alt" aria-hidden="true"></i>
                                </button>
                            </li>
                            <li v-if="folderToolbarData.file">
                                <button class="icon_btn"
                                    @click="downloadFileFromURlMethod(folderToolbarData.file, folderToolbarData.name)"
                                    title="Download">
                                    <i class="fa fa-download" aria-hidden="true"></i>
                                </button>
                            </li>
                            <li>
                                <button class="icon_btn" @click="openUpdateModal(folderToolbarData, false)"
                                    title="Rename">
                                    <i class="fa fa-pencil" aria-hidden="true"></i>
                                </button>
                            </li>
                            <li>
                                <button class="icon_btn text-danger-hover"
                                    @click="openDeleteModal(folderToolbarData, false)" title="Delete">
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- Subfolder Toolbar -->
                <div class="folder_toolbar_wrp"
                    v-if="!firstStepOfToolbarState && !selectedFolderForFirstStep && secondStepOfToolbarState">
                    <div class="d-flex align-items-center justify-content-between w-100">
                        <div class="d-flex align-items-center text-truncate">
                            <i class="fa fa-angle-left nav_back_btn" aria-hidden="true"
                                @click="backToFirstStepFromSecondStepMethod"></i>
                            <h4 class="mb-0 selected_folder_heading text-truncate" :title="folderToolbarData.name">
                                {{ limitTo(folderToolbarData.name) }}
                            </h4>
                        </div>
                        <ul class="list_icon justify-content-end mb-0">
                            <li>
                                <button class="icon_btn" @click="selectedOptionForNewSubFolderMethod('uploadFiles')"
                                    :class="{ active: filesUploadState }" title="Create File">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                                            viewBox="0 0 512 512">
                                            <path fill="currentColor" d="m354.78 66.76 53.91.09-53.91-53.91zm0 0" />
                                            <path fill="currentColor"
                                                d="m339.58 97.08c-8.37-.02-15.15-6.8-15.15-15.18v-81.9h-257.41c-8.38 0-15.18 6.79-15.18 15.18v270.46c15.8-6.6 33.13-10.25 51.29-10.25 8.97 0 17.73.89 26.21 2.59-1.01-2.03-1.6-4.32-1.6-6.75 0-8.38 6.79-15.17 15.18-15.17h182.77c8.38 0 15.18 6.79 15.18 15.17 0 8.38-6.8 15.18-15.18 15.18h-169.49c47.27 20.57 80.41 67.71 80.41 122.46 0 21.25-5 41.36-13.88 59.21h184.84c8.38 0 15.18-6.79 15.18-15.18v-355.68zm-68.52 54.77c0 8.38-6.8 15.18-15.18 15.18h-112.96c-8.38 0-15.18-6.8-15.18-15.18 0-8.38 6.8-15.18 15.18-15.18h112.96c8.38 0 15.18 6.8 15.18 15.18zm54.63 74.87h-182.77c-8.38 0-15.18-6.8-15.18-15.18 0-8.38 6.8-15.18 15.18-15.18h182.77c8.38 0 15.18 6.8 15.18 15.18 0 8.38-6.8 15.18-15.18 15.18z" />
                                            <path fill="currentColor"
                                                d="m206.26 408.87c0-56.87-46.26-103.13-103.13-103.13-56.87 0-103.13 46.26-103.13 103.13 0 56.87 46.26 103.13 103.13 103.13 56.87 0 103.13-46.27 103.13-103.13zm-73.45 15.18h-14.5v14.5c0 8.38-6.8 15.18-15.18 15.18-8.38 0-15.18-6.8-15.18-15.18v-14.5h-14.5c-8.38 0-15.18-6.8-15.18-15.18 0-8.38 6.8-15.18 15.18-15.18h14.5v-14.5c0-8.38 6.8-15.18 15.18-15.18 8.38 0 15.18 6.8 15.18 15.18v14.5h14.5c8.38 0 15.18 6.8 15.18 15.18 0 8.38-6.8 15.18-15.18 15.18z" />
                                        </svg>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- Selected Subfolder Toolbar -->
                <div class="folder_toolbar_wrp"
                    v-if="!firstStepOfToolbarState && !secondStepOfToolbarState && !selectedFolderForFirstStep && selectedSubFolderForToolbar">
                    <div class="d-flex align-items-center justify-content-between w-100">
                        <div class="d-flex align-items-center text-truncate">
                            <i class="fa fa-angle-left nav_back_btn" aria-hidden="true"
                                @click="backToSecondStepMethod"></i>
                            <h4 class="mb-0 selected_folder_heading text-truncate"
                                :title="selectedSubfolderToolbarData.name">
                                {{ limitTo(selectedSubfolderToolbarData.name) }}
                            </h4>
                        </div>
                        <ul class="list_icon justify-content-end mb-0">
                            <li>
                                <button class="icon_btn"
                                    @click="showShareBriefcasePopupMethod(selectedSubfolderToolbarData)" title="Share">
                                    <i class="fa fa-share-alt" aria-hidden="true"></i>
                                </button>
                            </li>
                            <li v-if="selectedSubfolderToolbarData.file">
                                <a :href="selectedSubfolderToolbarData.file" download target="_blank" class="icon_btn"
                                    title="Download">
                                    <i class="fa fa-download" aria-hidden="true"></i>
                                </a>
                            </li>
                            <li>
                                <button class="icon_btn"
                                    @click="openUpdateModal(selectedSubfolderToolbarData, false)"
                                    title="Rename">
                                    <i class="fa fa-pencil" aria-hidden="true"></i>
                                </button>
                            </li>
                            <li>
                                <button class="icon_btn text-danger-hover"
                                    @click="openDeleteModal(selectedSubfolderToolbarData, false)" title="Delete">
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- Shared First-Step Toolbar -->
                <div class="folder_toolbar_wrp shared_briefcase_toolbar_wrp"
                    v-if="!firstStepOfToolbarState && selectedSharedFolderForFirstStep">
                    <div class="d-flex align-items-center justify-content-between w-100">
                        <div class="d-flex align-items-center text-truncate">
                            <i class="fa fa-angle-left nav_back_btn" aria-hidden="true"
                                @click="backToFirstStepOfSharedListMethod"></i>
                            <h4 class="mb-0 selected_folder_heading text-truncate"
                                :title="folderToolbarData.first_name + ' ' + (folderToolbarData.last_name || '')">
                                {{ folderToolbarData.first_name }} {{ limitToULN(folderToolbarData.last_name) }}
                            </h4>
                        </div>
                    </div>
                </div>

                <!-- Shared Subfolder Toolbar Step 2 -->
                <div class="folder_toolbar_wrp shared_briefcase_toolbar_wrp"
                    v-if="!selectedSharedFolderForFirstStep && selectedSharedFolderForSecondStep">
                    <div class="d-flex align-items-center justify-content-between w-100">
                        <div class="d-flex align-items-center text-truncate">
                            <i class="fa fa-angle-left nav_back_btn" aria-hidden="true"
                                @click="backToFirstStepFromSecOfSharedListMethod"></i>
                            <h4 class="mb-0 selected_folder_heading text-truncate"
                                :title="selectedSubfolderToolbarData.name">
                                {{ limitTo(selectedSubfolderToolbarData.name) }}
                            </h4>
                        </div>
                        <ul class="list_icon justify-content-end mb-0">
                            <li v-if="selectedSubfolderToolbarData.file">
                                <button class="icon_btn"
                                    @click="downloadFileFromURlMethod(selectedSubfolderToolbarData.file, selectedSubfolderToolbarData.name)">
                                    <i class="fa fa-download" aria-hidden="true"></i>
                                </button>
                            </li>
                            <li>
                                <button class="icon_btn"
                                    @click="openUpdateModal(selectedSubfolderToolbarData, true, 'selectedSubfolderToolbarData')">
                                    <i class="fa fa-pencil" aria-hidden="true"></i>
                                </button>
                            </li>
                            <li>
                                <button class="icon_btn text-danger-hover"
                                    @click="openDeleteModal(selectedSubfolderToolbarData, true, 'selectedSubfolderToolbarData')">
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- Shared Subfolder Toolbar Step 3 -->
                <div class="folder_toolbar_wrp shared_briefcase_toolbar_wrp"
                    v-if="!selectedSharedFolderForSecondStep && selectedSharedFolderForThirdStep">
                    <div class="d-flex align-items-center justify-content-between w-100">
                        <div class="d-flex align-items-center text-truncate">
                            <i class="fa fa-angle-left nav_back_btn" aria-hidden="true"
                                @click="backToSecStepFromThirdOfSharedListMethod"></i>
                            <h4 class="mb-0 selected_folder_heading text-truncate"
                                :title="sharedBriefcaseThirdStepToolbarData.name">
                                {{ limitTo(sharedBriefcaseThirdStepToolbarData.name) }}
                            </h4>
                        </div>
                    </div>
                </div>

                <!-- Shared Subfolder Toolbar Step 4 -->
                <div class="folder_toolbar_wrp shared_briefcase_toolbar_wrp"
                    v-if="!selectedSharedFolderForThirdStep && selectedSharedFolderForFourStep">
                    <div class="d-flex align-items-center justify-content-between w-100">
                        <div class="d-flex align-items-center text-truncate">
                            <i class="fa fa-angle-left nav_back_btn" aria-hidden="true"
                                @click="backToThirdStepFromFourOfSharedListMethod"></i>
                            <h4 class="mb-0 selected_folder_heading text-truncate"
                                :title="sharedBriefcaseFourStepToolbarData.name">
                                {{ limitTo(sharedBriefcaseFourStepToolbarData.name) }}
                            </h4>
                        </div>
                        <ul class="list_icon justify-content-end mb-0">
                            <li v-if="sharedBriefcaseFourStepToolbarData.file">
                                <button class="icon_btn"
                                    @click="downloadFileFromURlMethod(sharedBriefcaseFourStepToolbarData.file, sharedBriefcaseFourStepToolbarData.name)">
                                    <i class="fa fa-download" aria-hidden="true"></i>
                                </button>
                            </li>
                            <li>
                                <button class="icon_btn"
                                    @click="openUpdateModal(sharedBriefcaseFourStepToolbarData, true, 'sharedBriefcaseFourStepToolbarData')">
                                    <i class="fa fa-pencil" aria-hidden="true"></i>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- Briefcase Header End -->

            <!-- Briefcase Main Body -->
            <div class="briefcase_main_body" v-if="normalBriefcaseViewState">
                <percentageLoader :uploadProgressState="uploadProgress" v-if="uploadProgress > 0 && submitted">
                </percentageLoader>

                <!-- Section Title Badge & Count -->
                <div class="section_title_badge" v-if="firstStepOfBriefcaseState && !isFormOpen">
                    <span class="title_text">{{ mainBriefcaseListState ? 'PERSONAL Briefcase' : 'SHARED Briefcase'
                        }}</span>
                    <span class="count_pill">
                        {{ mainBriefcaseListState ? getAllBriefcaseListResults.length :
                        getAllSharedBriefcaseByUserSpcficList.length }}
                    </span>
                </div>

                <!-- Primary Briefcase Listing -->
                <div class="briefcase_list_wrp"
                    v-if="firstStepOfBriefcaseState && !secondStepOfBriefcaseState && !isFormOpen">
                    <template v-if="mainBriefcaseListState">
                        <template v-if="getAllBriefcaseList">
                            <div v-if="getAllBriefcaseListResults.length > 0" class="cards_container"
                                :class="gridToList ? 'list_mode' : 'grid_mode'">
                                <div class="briefcase_card_item" v-for="items in getAllBriefcaseListResults"
                                    :key="items.id" :class="{ is_selected: folderToolbarData.id === items.id }"
                                    @click="enbaledFolderToolbarMethod(items)" @dblclick="enterSubFoldersMethod(items)">
                                    <div class="card_icon_wrap">
                                        <span v-if="items.is_folder" class="svg_icon_holder">
                                            <i class="fa fa-folder-open" aria-hidden="true"></i>
                                        </span>
                                        <span v-else class="svg_icon_holder file_holder">
                                            <img :src="checkFileExtension(items.file)" alt="File Icon"
                                                class="img-fluid" />
                                        </span>
                                    </div>

                                    <div class="card_content">
                                        <span class="card_title" :title="items.name">
                                            {{ gridToList ? items.name : limitToFileName(items.name) }}
                                        </span>
                                        <div class="card_meta">
                                            <i class="fa fa-clock-o mr-1" aria-hidden="true"></i>
                                            <span>{{ items.created_at | LocalDateFormat}}</span>
                                        </div>
                                    </div>

                                    <div class="card_quick_action" title="Share"
                                        @click.stop="showShareBriefcasePopupMethod(items)">
                                        <i class="fa fa-share-alt" aria-hidden="true"></i>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="no_data_state">
                                <i class="fa fa-folder-open-o mb-2 empty_icon" aria-hidden="true"></i>
                                <p>You may start storing your files here. Use the action bar above to add folders or
                                    documents.</p>
                            </div>
                        </template>
                    </template>

                    <!-- Shared Briefcase Directory -->
                    <template v-else>
                        <template v-if="getAllSharedBriefcaseByUserSpcficState">
                            <div v-if="getAllSharedBriefcaseByUserSpcficList.length > 0" class="cards_container"
                                :class="gridToList ? 'list_mode' : 'grid_mode'">
                                <div class="briefcase_card_item" v-for="items in getAllSharedBriefcaseByUserSpcficList"
                                    :key="items.id" @dblclick="enterSharedFolderByUserSpcficMethod(items)">
                                    <div class="card_icon_wrap">
                                        <span class="svg_icon_holder user_holder">
                                            <i class="fa fa-user" aria-hidden="true"></i>
                                        </span>
                                    </div>
                                    <div class="card_content">
                                        <span class="card_title">{{ items.first_name }} {{ items.last_name }}</span>
                                        <div class="card_meta">
                                            <span>Shared Member</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="no_data_state">
                                <p>You don't have any shared briefcases.</p>
                            </div>
                        </template>

                        <!-- Nested Shared Items -->
                        <template v-else>
                            <div v-if="getAllSharedBriefcaseListResults.length > 0" class="cards_container"
                                :class="gridToList ? 'list_mode' : 'grid_mode'">
                                <div class="briefcase_card_item" v-for="items in getAllSharedBriefcaseListResults"
                                    :key="items.id"
                                    :class="{ is_selected: selectedSubfolderToolbarData.id === items.briefcase_folder.id }"
                                    @dblclick="enterSubSharedFolderMethod(items.briefcase_folder)"
                                    @click="enbaledSharedSubFolderToolbarMethod(items)">
                                    <div class="card_icon_wrap">
                                        <span class="svg_icon_holder">
                                            <i v-if="items.briefcase_folder.is_folder" class="fa fa-folder-open"
                                                aria-hidden="true"></i>
                                            <img v-else :src="checkFileExtension(items.briefcase_folder.file)"
                                                alt="File Type" class="img-fluid" />
                                        </span>
                                    </div>
                                    <div class="card_content">
                                        <span class="card_title" :title="items.briefcase_folder.name">
                                            {{ gridToList ? items.briefcase_folder.name :
                                            limitToFileName(items.briefcase_folder.name) }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </template>
                </div>

                <!-- Subfolder Step Body -->
                <div class="subfolder_section_wrp"
                    v-if="!firstStepOfBriefcaseState && secondStepOfBriefcaseState && !isFormOpen">
                    <div class="briefcase_list_wrp" v-if="subfolderListState">
                        <div class="cards_container" :class="gridToList ? 'list_mode' : 'grid_mode'"
                            v-if="subfolderFiles.length > 0">
                            <div class="briefcase_card_item" v-for="items in subfolderFiles"
                                :key="items.id"
                                :class="{ is_selected: selectedSubfolderToolbarData.id === items.id }"
                                @click="enbaledSubFolderToolbarMethod(items)">
                                <div class="card_icon_wrap">
                                    <span class="svg_icon_holder file_holder">
                                        <img :src="checkFileExtension(items.file)" alt="File Type" class="img-fluid" />
                                    </span>
                                </div>
                                <div class="card_content">
                                    <span class="card_title" :title="items.name">{{ limitToFileName(items.name)
                                        }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Integrated Creation / Upload Surfaces -->
                <div class="create_briefcase_data form_surface" v-if="isFormOpen">
                    <!-- Folder Upload Form -->
                    <form v-if="foldersUploadState" @submit.prevent="folderUploadInBriefcaseMethod">
                        <div class="form-group mb-3">
                            <label class="custom_file_dropzone" for="folderUploadId" :class="uploadedFolderName ? 'uploaded' : ''">
                                <input type="file" id="folderUploadId" name="folderRef" ref="folderRef"
                                    @change="handleAttachmentFolderUpload" v-validate="'required'" webkitdirectory />
                                <i class="fa fa-folder-open mb-2" aria-hidden="true"></i>
                                <span>{{ uploadedFolderName || 'Select Folder to Upload' }}</span>
                            </label>
                            <small class="invalid-feedback d-block" v-if="errors.has('folderRef')">The folder is
                                required</small>
                        </div>
                        <div class="d-flex justify-content-end">
                            <button type="button" class="btn btn-secondary mr-2" @click="cancelAllCreationForms"
                                :disabled="submitted">
                                Cancel
                            </button>
                            <button type="submit" class="btn btn-action-blue" :disabled="submitted">
                                Upload
                            </button>
                        </div>
                    </form>

                    <!-- Files Upload Form -->
                    <form v-else-if="filesUploadState" @submit.prevent="handleUnifiedFilesSubmit">
                        <div class="form-group mb-3">
                            <label class="custom_file_dropzone" for="upload_attachment" :class="fileName ? 'uploaded' : ''">
                                <input type="file" id="upload_attachment" name="file" ref="file"
                                    @change="handleAttachmentUpload" v-validate="'required'" multiple />
                                <i class="fa fa-cloud-upload mb-2" aria-hidden="true"></i>
                                <span v-if="!fileName">Select Files to Upload</span>
                                <span v-else>{{ uploadedFilesState.length > 1 ? `${uploadedFilesState.length} Files
                                    Selected` : fileName
                                    }}</span>
                            </label>
                            <small class="invalid-feedback d-block" v-if="errors.has('file')">{{ errors.first('file')
                                }}</small>
                        </div>
                        <div class="d-flex justify-content-end">
                            <button type="button" class="btn btn-secondary mr-2" @click="cancelAllCreationForms"
                                :disabled="submitted">
                                Cancel
                            </button>
                            <button type="submit" class="btn btn-action-blue" :disabled="submitted">
                                Upload
                            </button>
                        </div>
                    </form>

                    <!-- New Folder Form -->
                    <form v-else-if="newFolderState" @submit.prevent="createNewBriefcaseDataMethod">
                        <div class="form-group mb-3">
                            <label class="form_label">Folder Name</label>
                            <input type="text" class="form-control" v-validate="'required'" v-model.trim="folderName"
                                name="folderName" :class="{ 'is-invalid': errors.has('folderName') }"
                                placeholder="Project Docs" autocomplete="off" />
                            <small class="invalid-feedback" v-if="errors.has('folderName')">{{
                                errors.first('folderName') }}</small>
                        </div>
                        <div class="d-flex justify-content-end">
                            <button type="button" class="btn btn-secondary mr-2" @click="cancelAllCreationForms">
                                Cancel
                            </button>
                            <button type="submit" class="btn btn-action-blue" :disabled="submitted">
                                Create
                            </button>
                        </div>
                    </form>
                </div>

                <!-- Storage Meta Info -->
                <template v-if="firstStepOfBriefcaseState && !secondStepOfBriefcaseState && !isFormOpen">
                    <briefCaseStorgeInfo v-if="mainBriefcaseListState"></briefCaseStorgeInfo>
                </template>
            </div>

            <!-- Alternate View: Breakdown & Activity Log -->
            <div class="briefcase_main_body" v-else>
                <briefcaseStorageBreakdown v-if="briefcaseStorageBreakdownState"></briefcaseStorageBreakdown>
                <briefcaseActivityLog v-if="briefcaseActivityLogState"></briefcaseActivityLog>
            </div>
        </div>

        <!-- Separate Delete Modal -->
        <BriefcaseDeleteModal
            :visible="deleteModal.visible"
            :target-item="deleteModal.item"
            :is-shared="deleteModal.isShared"
            :loading="deleteModal.loading"
            @close="closeDeleteModal"
            @confirm="handleDeleteConfirm"
        />

        <!-- Separate Update / Rename Modal -->
        <BriefcaseUpdateModal
            :visible="updateModal.visible"
            :target-item="updateModal.item"
            :is-shared="updateModal.isShared"
            :loading="updateModal.loading"
            @close="closeUpdateModal"
            @confirm="handleUpdateConfirm"
        />

        <!-- Additional Component Modals & Alerts -->
        <notes-briefcase v-if="sharedBriefcasePopupState" :sharedBriefcaseINFO="sharedBriefcaseInfo"></notes-briefcase>
        <errorStorageFull v-if="errorStorageFullState"></errorStorageFull>
    </div>
</template>

<script>
import axios from 'axios';
import { bus } from '@/main';
import root from '@/_helpers/roots';
import briefCaseStorgeInfo from './briefcase-storage-info/index.vue';
import briefcaseActivityLog from './briefcase-activity-log/index.vue';
import briefcaseStorageBreakdown from './briefcaseStorageBreakdown/index.vue';
import errorStorageFull from './error-storage-full/index.vue';
import percentageLoader from '@/components/common/percentage-loader-f-file';
import sharedBriefcase from './shared-briefcase/index.vue';
import BriefcaseDeleteModal from './BriefcaseDeleteModal.vue';
import BriefcaseUpdateModal from './BriefcaseUpdateModal.vue';

const uploadFolderInBriefcaseApiUrl = root.uploadFolderInBriefcaseApiUrl.link;
const uploadFilesInBriefcaseApiUrl = root.uploadFilesInBriefcaseApiUrl.link;

const FILE_ICONS = {
    jpg: 'jpg.png',
    jpeg: 'jpg.png',
    png: 'png.png',
    gif: 'jpg.png',
    zip: 'zip.png',
    rar: 'zip-1.png',
    eps: 'ai.png',
    pdf: 'pdf.png',
    css: 'css.png',
    csv: 'csv.png',
    doc: 'doc.png',
    docx: 'doc.png',
    json: 'json-file.png',
    ppt: 'ppt.png',
    pptx: 'ppt.png',
    txt: 'txt.png',
    xls: 'xls.png',
    xlsx: 'xls.png',
    xml: 'xml.png',
    xlsm: 'xls.png',
    py: 'python.png',
    cpp: 'cpp-file-format-symbol.png',
    vbb: 'coding.png',
    default: 'd_file.png'
};

export default {
    name: 'briefcase',
    components: {
        'notes-briefcase': sharedBriefcase,
        briefCaseStorgeInfo,
        briefcaseStorageBreakdown,
        errorStorageFull,
        briefcaseActivityLog,
        percentageLoader,
        BriefcaseDeleteModal,
        BriefcaseUpdateModal
    },
    data() {
        return {
            submitted: false,
            folderName: '',
            fileName: '',
            newFolderState: false,
            uploadedFilesState: [],
            filesUploadState: false,
            foldersUploadState: false,
            getAllBriefcaseList: null,
            getAllBriefcaseListResults: [],
            firstStepOfBriefcaseState: true,
            firstStepOfToolbarState: true,
            selectedFolderForFirstStep: false,
            folderToolbarData: {},
            secondStepOfBriefcaseState: false,
            secondStepOfToolbarState: false,
            subfolderListState: false,
            selectedSubFolderForToolbar: false,
            selectedSubfolderToolbarData: {},
            gridToList: false,
            getAllSharedBriefcaseList: {},
            getAllSharedBriefcaseListResults: [],
            mainBriefcaseListState: true,
            sharedBriefcaseListState: false,
            sharedBriefcasePopupState: false,
            sharedBriefcaseInfo: {},
            getAllSharedBriefcaseByUserSpcficList: [],
            getAllSharedBriefcaseByUserSpcficState: true,
            selectedSharedFolderForFirstStep: false,
            selectedSharedFolderForSecondStep: false,
            selectedSharedFolderForThirdStep: false,
            selectedSharedFolderForFourStep: false,
            secondStepOfSharedBriefcaseState: false,
            sharedBriefcaseLastStepToolbarData: {},
            sharedBriefcaseThirdStepToolbarData: {},
            sharedBriefcaseFourStepToolbarData: {},
            selectedSharedBriefcaseDeleteID: '',
            normalBriefcaseViewState: true,
            errorStorageFullState: false,
            briefcaseStorageBreakdownState: false,
            briefcaseActivityLogState: false,
            uploadedFolderName: '',
            uploadedFolderitems: [],
            uploadProgress: 0,
            deleteModal: {
                visible: false,
                isShared: false,
                item: {},
                contextKey: '',
                loading: false
            },
            updateModal: {
                visible: false,
                isShared: false,
                item: {},
                contextKey: '',
                loading: false
            }
        };
    },
    computed: {
        isFormOpen() {
            return this.filesUploadState || this.foldersUploadState || this.newFolderState;
        },
        subfolderFiles() {
            if (!this.folderToolbarData || !this.folderToolbarData.sub_folders) {
                return [];
            }
            return this.folderToolbarData.sub_folders.filter((item) => item.is_file);
        }
    },
    mounted() {
        this.getBriefcaseListMethod();

        bus.$on('sharedBriefcasePopupStateBus', this.onSharedBriefcasePopup);
        bus.$on('normalBriefcaseViewStateBus', this.onNormalBriefcaseView);
        bus.$on('briefcaseStorageBreakdownStateBus', this.onStorageBreakdown);
        bus.$on('briefcaseActivityLogStateBus', this.onActivityLog);
        bus.$on('errorStorageFullStateBus', this.onErrorStorageFull);
    },
    beforeDestroy() {
        bus.$off('sharedBriefcasePopupStateBus', this.onSharedBriefcasePopup);
        bus.$off('normalBriefcaseViewStateBus', this.onNormalBriefcaseView);
        bus.$off('briefcaseStorageBreakdownStateBus', this.onStorageBreakdown);
        bus.$off('briefcaseActivityLogStateBus', this.onActivityLog);
        bus.$off('errorStorageFullStateBus', this.onErrorStorageFull);
    },
    methods: {
        onSharedBriefcasePopup(data) {
            this.sharedBriefcasePopupState = data;
        },
        onNormalBriefcaseView(data) {
            this.normalBriefcaseViewState = data;
        },
        onStorageBreakdown(data) {
            this.briefcaseStorageBreakdownState = data;
        },
        onActivityLog(data) {
            this.briefcaseActivityLogState = data;
        },
        onErrorStorageFull(data) {
            this.errorStorageFullState = data;
        },
        normalViewExit() {
            this.normalBriefcaseViewState = true;
            this.briefcaseStorageBreakdownState = false;
            this.briefcaseActivityLogState = false;
        },
        showShareBriefcasePopupMethod(data) {
            this.sharedBriefcasePopupState = true;
            this.sharedBriefcaseInfo = data;
        },
        showSharedBriefcaseMethod() {
            if (this.mainBriefcaseListState) {
                this.mainBriefcaseListState = false;
                this.getSharedBriefcaseByUserSpcficListMethod();
            } else {
                this.mainBriefcaseListState = true;
            }
        },
        gridChangeToListForFirstStepMethod() {
            this.cancelAllCreationForms();
            this.gridToList = !this.gridToList;
            this.firstStepOfBriefcaseState = true;
        },
        limitTo(value) {
            if (!value) return '';
            return value.length > 20 ? `${value.substring(0, 20)}...` : value;
        },
        limitToFileName(value) {
            if (!value) return '';
            return value.length > 18 ? `${value.substring(0, 18)}...` : value;
        },
        limitToULN(value) {
            if (!value) return '';
            return value.length > 10 ? `${value.substring(0, 10)}...` : value;
        },
        getBriefcaseListMethod() {
            this.$store
                .dispatch('getbriefcaselistAction')
                .then((res) => {
                    this.getAllBriefcaseList = res.data.data;
                    this.getAllBriefcaseListResults = res.data.data.results || [];
                    this.getSharedBriefcaseByUserSpcficListMethod();
                })
                .catch(() => { });
        },
        selectionOfActionMethod(arg) {
            this.filesUploadState = arg === 'uploadFiles';
            this.newFolderState = arg === 'newFolder';
            this.foldersUploadState = arg === 'uploadFolders';
        },
        selectedOptionForNewBriefcaseMethod(arg) {
            this.firstStepOfBriefcaseState = false;
            this.selectionOfActionMethod(arg);
        },
        selectedOptionForNewSubFolderMethod(arg) {
            this.subfolderListState = false;
            this.selectionOfActionMethod(arg);
        },
        handleAttachmentUpload(event) {
            if (event.target.files && event.target.files.length > 0) {
                this.uploadedFilesState = Array.from(event.target.files);
                this.fileName = this.uploadedFilesState[0].name;
            } else {
                this.uploadedFilesState = [];
                this.fileName = '';
            }
        },
        handleAttachmentFolderUpload(event) {
            if (!event.target.files || event.target.files.length === 0) return;
            this.uploadedFolderName = event.target.files[0].webkitRelativePath.split('/')[0];
            this.uploadedFolderitems = Array.from(event.target.files);
        },
        handleUnifiedFilesSubmit() {
            if (this.secondStepOfBriefcaseState) {
                this.createNewSubFolderBriefcaseDataMethod();
            } else {
                this.createNewBriefcaseDataMethod();
            }
        },
        createNewBriefcaseDataMethod() {
            this.$validator.validateAll().then((result) => {
                if (!result) return;
                this.submitted = true;

                if (this.filesUploadState) {
                    const formData = new FormData();
                    this.uploadedFilesState.forEach((file) => formData.append('files', file));

                    axios
                        .post(uploadFilesInBriefcaseApiUrl, formData, {
                            onUploadProgress: (progressEvent) => {
                                this.uploadProgress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                            }
                        })
                        .then(() => {
                            this.onFormSuccessReset();
                        })
                        .catch((err) => {
                            this.submitted = false;
                            if (err && err.status === 406) {
                                this.errorStorageFullState = true;
                            }
                        });
                } else {
                    const payload = { name: this.folderName, is_folder: true };
                    this.$store
                        .dispatch('createBriefcaseDetailsAction', payload)
                        .then(() => {
                            this.onFormSuccessReset();
                        })
                        .catch(() => {
                            this.submitted = false;
                        });
                }
            });
        },
        createNewSubFolderBriefcaseDataMethod() {
            this.$validator.validateAll().then((result) => {
                if (!result) return;
                this.submitted = true;

                const formData = new FormData();
                formData.append('parent_id', this.folderToolbarData.id);
                this.uploadedFilesState.forEach((file) => formData.append('files', file));

                axios
                    .post(uploadFilesInBriefcaseApiUrl, formData, {
                        onUploadProgress: (progressEvent) => {
                            this.uploadProgress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                        }
                    })
                    .then(() => {
                        this.submitted = false;
                        this.uploadProgress = 0;
                        this.filesUploadState = false;
                        this.newFolderState = false;
                        this.fileName = '';
                        this.uploadedFilesState = [];
                        this.$validator.reset();

                        this.$store
                            .dispatch('getBriefcaseDetailsByIdAction', { id: this.folderToolbarData.id })
                            .then((res) => {
                                this.folderToolbarData = res.data.data;
                                this.subfolderListState = true;
                            });
                        this.getBriefcaseListMethod();
                    })
                    .catch(() => {
                        this.submitted = false;
                    });
            });
        },
        folderUploadInBriefcaseMethod() {
            this.$validator.validateAll().then((result) => {
                if (!result) return;
                this.submitted = true;

                const formData = new FormData();
                formData.append('folder_name', this.uploadedFolderName);
                this.uploadedFolderitems.forEach((file) => formData.append('files', file));

                axios
                    .post(uploadFolderInBriefcaseApiUrl, formData, {
                        onUploadProgress: (progressEvent) => {
                            this.uploadProgress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                        }
                    })
                    .then(() => {
                        this.uploadedFolderName = '';
                        this.uploadedFolderitems = [];
                        this.onFormSuccessReset();
                    })
                    .catch(() => {
                        this.submitted = false;
                    });
            });
        },
        onFormSuccessReset() {
            this.submitted = false;
            this.uploadProgress = 0;
            this.foldersUploadState = false;
            this.filesUploadState = false;
            this.newFolderState = false;
            this.firstStepOfBriefcaseState = true;
            this.folderName = '';
            this.fileName = '';
            this.uploadedFilesState = [];
            this.$validator.reset();
            this.getBriefcaseListMethod();
            this.$store.dispatch('getbriefcaseStorageInfoAction');
        },
        checkFileExtension(file) {
            if (!file) return require(`@/assets/images/filetype/${FILE_ICONS.default}`);
            const extension = file.substr(file.lastIndexOf('.') + 1).split('?')[0].toLowerCase();
            const filename = FILE_ICONS[extension] || FILE_ICONS.default;
            return require(`@/assets/images/filetype/${filename}`);
        },
        enbaledFolderToolbarMethod(itemData) {
            this.folderToolbarData = itemData;
            this.firstStepOfToolbarState = false;
            this.selectedFolderForFirstStep = true;
        },
        enbaledSubFolderToolbarMethod(itemData) {
            this.selectedSubfolderToolbarData = itemData;
            this.secondStepOfToolbarState = false;
            this.selectedSubFolderForToolbar = true;
        },

        // --- Separate Modal Helpers ---
        openDeleteModal(item, isShared = false, contextKey = '') {
            this.deleteModal = {
                visible: true,
                isShared,
                item,
                contextKey,
                loading: false
            };
        },
        closeDeleteModal() {
            this.deleteModal.visible = false;
            this.deleteModal.loading = false;
            this.resetToolbarStateAfterModal();
        },
        openUpdateModal(item, isShared = false, contextKey = '') {
            this.updateModal = {
                visible: true,
                isShared,
                item,
                contextKey,
                loading: false
            };
        },
        closeUpdateModal() {
            this.updateModal.visible = false;
            this.updateModal.loading = false;
            this.resetToolbarStateAfterModal();
        },
        resetToolbarStateAfterModal() {
            if (this.secondStepOfBriefcaseState) {
                this.secondStepOfToolbarState = true;
                this.selectedSubFolderForToolbar = false;
                // this.folderToolbarData = {};
            } else {
                this.firstStepOfToolbarState = true;
                this.selectedFolderForFirstStep = false;
                this.folderToolbarData = {};
            }
        },

        // --- Delete Confirmation ---
        handleDeleteConfirm({ item, isShared }) {
            this.deleteModal.loading = true;

            var actionName = isShared
                ? 'removeShareBriefcaseDetailsByIDAction'
                : 'removeBriefcaseDetailsByIdAction';

            var deleteId = isShared
                ? ((this.selectedSharedBriefcaseDeleteID && this.selectedSharedBriefcaseDeleteID.id) || item.id)
                : item.id;

            var payload = { id: deleteId };

            this.$store
                .dispatch(actionName, payload)
                .then(() => {
                    this.closeDeleteModal();
                    if (isShared) {
                        this.$store
                            .dispatch('getSharedBriefcaselistAction', { id: item.user })
                            .then((res) => {
                                this.getAllSharedBriefcaseList = res.data.data;
                                if (this.getAllSharedBriefcaseList) {
                                    this.getAllSharedBriefcaseListResults = this.getAllSharedBriefcaseList.results || [];
                                }
                            });
                        this.selectedSharedBriefcaseDeleteID = '';
                    } else {
                        this.getBriefcaseListMethod();
                        if (this.secondStepOfBriefcaseState && this.folderToolbarData.id) {
                            this.$store
                                .dispatch('getBriefcaseDetailsByIdAction', { id: this.folderToolbarData.id })
                                .then((res) => {
                                    this.folderToolbarData = res.data.data;
                                    this.subfolderListState = true;
                                });
                        }
                    }
                })
                .catch(() => {
                    this.deleteModal.loading = false;
                });
        },

        // --- Update / Rename Confirmation ---
        handleUpdateConfirm({ item, newName, isShared }) {
            this.updateModal.loading = true;

            var data = { name: newName };
            this.$store
                .dispatch('updateBriefcaseDetailsAction', { data: { id: item.id, data: data } })
                .then((res) => {
                    if (isShared) {
                        if (this.updateModal.contextKey === 'selectedSubfolderToolbarData') {
                            this.selectedSubfolderToolbarData = res.data.data;
                        }
                    } else {
                        this.getBriefcaseListMethod();
                        if (this.folderToolbarData.id) {
                            this.$store
                                .dispatch('getBriefcaseDetailsByIdAction', { id: this.folderToolbarData.id })
                                .then((resInner) => {
                                    this.folderToolbarData = resInner.data.data;
                                });
                        }
                    }
                    this.closeUpdateModal();
                })
                .catch(() => {
                    this.updateModal.loading = false;
                });
        },

        // Legacy compatibility shims
        removeBriefcaseDataMethod(rItemData) {
            this.openDeleteModal(rItemData, false);
        },
        openUpdateBriefcaseDetailPopup(updateData) {
            this.openUpdateModal(updateData, false);
        },
        removeSharedBriefcaseDataMethod(optDataKey, rItemData) {
            this.openDeleteModal(rItemData, true, optDataKey);
        },
        openUpdateSharedBriefcaseDetailPopup(optDataKey, updateData) {
            this.openUpdateModal(updateData, true, optDataKey);
        },

        enterSubFoldersMethod(itemData) {
            if (!itemData.is_folder) return;
            this.folderToolbarData = itemData;
            this.firstStepOfBriefcaseState = false;
            this.secondStepOfBriefcaseState = true;
            this.subfolderListState = true;
            this.firstStepOfToolbarState = false;
            this.selectedFolderForFirstStep = false;
            this.secondStepOfToolbarState = true;
        },
        downloadFileFromURlMethod(url, name) {
            const link = document.createElement('a');
            link.href = url;
            link.download = name;
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        backToFirstStepMethod() {
            this.folderToolbarData = {};
            this.selectedFolderForFirstStep = false;
            this.firstStepOfToolbarState = true;
        },
        backToFirstStepFromSecondStepMethod() {
            this.folderToolbarData = {};
            this.secondStepOfBriefcaseState = false;
            this.firstStepOfBriefcaseState = true;
            this.secondStepOfToolbarState = false;
            this.firstStepOfToolbarState = true;
            this.filesUploadState = false;
        },
        backToSecondStepMethod() {
            this.selectedSubfolderToolbarData = {};
            this.selectedSubFolderForToolbar = false;
            this.secondStepOfToolbarState = true;
        },
        cancelAllCreationForms() {
            this.folderName = '';
            this.fileName = '';
            this.uploadedFolderName = '';
            this.uploadedFilesState = [];
            this.uploadedFolderitems = [];
            this.filesUploadState = false;
            this.newFolderState = false;
            this.foldersUploadState = false;
            this.$validator.reset();

            if (this.secondStepOfBriefcaseState) {
                this.subfolderListState = true;
            } else {
                this.firstStepOfBriefcaseState = true;
            }
        },
        getSharedBriefcaseByUserSpcficListMethod() {
            this.$store
                .dispatch('getShareBriefcaseListUserSpecificAction')
                .then((res) => {
                    this.getAllSharedBriefcaseByUserSpcficList = res.data.data || [];
                })
                .catch(() => { });
        },
        enterSharedFolderByUserSpcficMethod(userSharedData) {
            this.$store
                .dispatch('getSharedBriefcaselistAction', { id: userSharedData.id })
                .then((res) => {
                    this.folderToolbarData = userSharedData;
                    this.getAllSharedBriefcaseList = res.data.data;
                    this.getAllSharedBriefcaseListResults = res.data.data ? res.data.data.results || [] : [];
                    this.getAllSharedBriefcaseByUserSpcficState = false;
                    this.firstStepOfToolbarState = false;
                    this.selectedSharedFolderForFirstStep = true;
                })
                .catch(() => { });
        },
        enterSubSharedFolderMethod(itemData) {
            if (!itemData.is_folder) return;
            this.$store
                .dispatch('getSharedBriefcaseDetailsByIDAction', { id: itemData.id })
                .then((res) => {
                    this.sharedBriefcaseLastStepToolbarData = res.data.data;
                    this.sharedBriefcaseThirdStepToolbarData = itemData;
                    if (this.sharedBriefcaseLastStepToolbarData.sub_folders && this.sharedBriefcaseLastStepToolbarData.sub_folders.length > 0) {
                        this.firstStepOfBriefcaseState = false;
                        this.secondStepOfSharedBriefcaseState = true;
                        this.selectedSharedFolderForSecondStep = false;
                        this.selectedSharedFolderForThirdStep = true;
                    }
                })
                .catch(() => { });
        },
        backToSecStepFromThirdOfSharedListMethod() {
            this.sharedBriefcaseLastStepToolbarData = {};
            this.selectedSharedFolderForThirdStep = false;
            this.selectedSharedFolderForSecondStep = true;
            this.secondStepOfSharedBriefcaseState = false;
            this.firstStepOfBriefcaseState = true;
        },
        backToFirstStepOfSharedListMethod() {
            this.folderToolbarData = {};
            this.selectedSharedFolderForFirstStep = false;
            this.getAllSharedBriefcaseByUserSpcficState = true;
            this.firstStepOfToolbarState = true;
        },
        enbaledSharedSubFolderToolbarMethod(itemData) {
            this.selectedSharedBriefcaseDeleteID = itemData;
            this.selectedSubfolderToolbarData = itemData.briefcase_folder;
            this.selectedSharedFolderForFirstStep = false;
            this.selectedSharedFolderForSecondStep = true;
        },
        backToFirstStepFromSecOfSharedListMethod() {
            this.selectedSubfolderToolbarData = {};
            this.selectedSharedFolderForSecondStep = false;
            this.selectedSharedFolderForFirstStep = true;
        },
        enbaledSubFolderToolbarOfLastSharedBriefcaseMethod(data) {
            this.sharedBriefcaseFourStepToolbarData = data;
            this.selectedSharedFolderForThirdStep = false;
            this.selectedSharedFolderForFourStep = true;
        },
        backToThirdStepFromFourOfSharedListMethod() {
            this.sharedBriefcaseFourStepToolbarData = {};
            this.selectedSharedFolderForFourStep = false;
            this.selectedSharedFolderForThirdStep = true;
        }
    }
};
</script>

<style lang="scss" scoped>
$bg-dark: #0a0e14;
$bg-card: #121824;
$bg-card-hover: #172030;
$border-card: #1f2838;
$text-primary: #e6edf3;
$text-secondary: #7e8794;
$accent-cyan: #94a3b8;
$accent-blue: #388bfd;
$accent-hover: #8abbff;

.briefcase_main_wrp {
    background: #111111;
    height: 100%;
    position: relative;
    color: $text-primary;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;

    .briefcase_main_list {
        height: 100%;
        position: relative;
    }

    // --- Header ---
    .briefcase_main_header {
        padding: 10px 14px;
        background: rgba(12, 13, 18, 0.7);
        backdrop-filter: blur(20px);
        -webkit-backdrop-filter: blur(20px);
        border-bottom: 1px solid rgba(255, 255, 255, 0.01);

        .list_icon {
            margin: 0;
            padding: 0;
            display: flex;
            align-items: center;
            list-style: none;

            li {
                margin-right: 8px;
            }
        }

        .icon_btn {
            background: rgba(255, 255, 255, 0.04);
            border: 1px solid rgba(255, 255, 255, 0.01);
            color: #94a3b8;
            width: 28px;
            height: 28px;
            border-radius: 5px;
            padding: 0;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            outline: none;
            -webkit-transition: all .2s cubic-bezier(.16, 1, .3, 1);
            transition: all .2s cubic-bezier(.16, 1, .3, 1);

            svg {
                fill: $accent-cyan;
                transition: fill 0.2s;
            }

            img{
                filter:brightness(0) saturate(100%) invert(67%) sepia(18%) saturate(350%) hue-rotate(178deg) brightness(92%) contrast(88%);
            }

            &:hover,
            &.active {
                background: rgba(255, 255, 255, 0.09);
                border-color: rgba(255, 255, 255, 0.18);
                color: #ffffff;
                -webkit-transform: translateY(-1px);
                transform: translateY(-1px);

                svg {
                    fill: #ffffff;
                }
                img{
                 filter:brightness(0) invert(1);
                }
            }

            &.text-danger-hover:hover {
                border-color: #f85149;
                color: #f85149;
            }
        }

        .btn-pill-dark {
            background: rgba(255, 255, 255, 0.04);
            border: 1px solid rgba(255, 255, 255, 0.01);
            color: #94a3b8;
            padding: 4px 14px;
            border-radius: 20px;
            font-size: 13px;
            font-weight: 500;
            display: inline-flex;
            align-items: center;
            transition: all .2s cubic-bezier(.16, 1, .3, 1);
            outline: none;

            &:hover {
                background: rgba(255, 255, 255, 0.09);
                border-color: rgba(255, 255, 255, 0.18);
                color: #ffffff;
                -webkit-transform: translateY(-1px);
                transform: translateY(-1px);
            }
        }

        .nav_back_btn {
            font-size: 26px;
            color: $text-secondary;
            margin-right: 12px;
            cursor: pointer;

            &:hover {
                color: #fff;
            }
        }

        .selected_folder_heading {
            font-size: 15px;
            font-weight: 600;
            color: #fff;
        }
    }

    // --- Body ---
    .briefcase_main_body {
        padding: 16px;
        height: calc(100% - 50px);
        overflow-y: auto;
        background: #0b0c10;
        backdrop-filter: blur(20px);

        &::-webkit-scrollbar {
            width: 4px;
        }

        &::-webkit-scrollbar-thumb {
            border-radius: 4px;
            background: rgba(255, 255, 255, 0.12);
        }
    }

    // --- Title & Pill Badge ---
    .section_title_badge {
        display: flex;
        align-items: center;
        margin-bottom: 12px;

        .title_text {
            font-size: 11px;
            font-weight: 700;
            letter-spacing: 0.8px;
            color: $text-secondary;
            text-transform: uppercase;
            margin-right: 8px;
        }

        .count_pill {
            background: #161e2b;
            color: #8b949e;
            font-size: 11px;
            font-weight: 600;
            padding: 1px 7px;
            border-radius: 12px;
            border: 1px solid rgba(255, 255, 255, 0.04);
        }
    }

    // --- Cards & Grid/List View ---
    .cards_container {
        // 1. List View
        &.list_mode {
            display: flex;
            flex-direction: column;
            gap: 10px;

            .briefcase_card_item {
                display: flex;
                flex-direction: row;
                align-items: center;
                padding: 12px 14px;
                width: 100%;

                .card_icon_wrap {
                    margin-right: 14px;
                    margin-bottom: 0;
                }

                .card_content {
                    text-align: left;
                }
            }
        }

        // 2. Grid View
        &.grid_mode {
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
            gap: 10px;

            .briefcase_card_item {
                display: flex;
                flex-direction: column;
                align-items: center;
                text-align: center;
                padding: 15px 10px;
                position: relative;

                .card_icon_wrap {
                    margin-right: 0;
                    margin-bottom: 10px;

                    .svg_icon_holder {
                        font-size: 20px;
                    }
                }

                .card_content {
                    width: 100%;

                    .card_title {
                        font-size: 13px;
                    }

                    .card_meta {
                        justify-content: center;
                        font-size: 11px;
                    }
                }

                .card_quick_action {
                    position: absolute;
                    top: 8px;
                    right: 8px;
                }
            }
        }
    }

    // Individual Card Item
    .briefcase_card_item {
        background: rgba(22, 24, 33, 0.5);
        backdrop-filter: blur(20px);
        -webkit-backdrop-filter: blur(20px);
        border: 1px solid rgba(255, 255, 255, 0.01);
        border-top-color: rgba(255, 255, 255, 0.03);
        border-radius: 12px;
        cursor: pointer;
        transition: background 0.15s ease, border-color 0.15s ease;

        &:hover {
            background: rgba(255, 255, 255, 0.05);
            border-color: rgba(255, 255, 255, 0.1);
            transform: translateY(-2px);
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
        }

        &.is_selected {
            background: rgba(33, 228, 0, 0.08);
            border-color: rgba(33, 228, 0, 0.2);
            transform: translateY(-2px);
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
            *{
                color: #21e400 !important;
            }
        }

        .card_icon_wrap {
            flex-shrink: 0;

            .svg_icon_holder {
                width: 40px;
                height: 40px;
                background: rgba(135, 206, 250, .1);
                border: 1px solid rgba(135, 206, 250, .2);
                border-radius: 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #87cefa;
                font-size: 18px;

                img {
                    max-width: 24px;
                }

                &.user_holder {
                    color: $accent-cyan;
                }
            }
        }

        .card_content {
            flex-grow: 1;
            min-width: 0;

            .card_title {
                display: block;
                font-size: 14px;
                font-weight: 500;
                color: #f0f6fc;
                margin-bottom: 2px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            .card_meta {
                font-size: 11px;
                font-weight: 500;
                color: #5e6473;
                line-height: 1;
                display: flex;
                align-items: center;
                margin-top: 8px;
            }
        }

        .card_quick_action {
            background: transparent;
            border: none;
            color: #7e8794;
            width: 28px;
            height: 28px;
            border-radius: 6px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            opacity: 1;
            transition: all 0.15s ease;
            flex-shrink: 0;

            &:hover {
                background: rgba(255, 255, 255, 0.08);
                color: #ffffff !important;
                & .fa-share-alt{
                    color:#ffffff !important;
                }
            }
        }
    }

    // --- Form & Dropzone ---
    .form_surface {
        background: rgba(22, 24, 33, .5);
        border: 1px solid rgba(255, 255, 255, 0.01);
        border-radius: 12px;
        padding: 18px;
        margin-bottom: 16px;

        .form_label {
            color: $text-secondary;
            font-size: 13px;
            font-weight: 500;
            margin-bottom: 6px;
        }

        .form-control {
            background: transparent;
            border: 1px solid rgba(255, 255, 255, 0.1);
            border-radius: 6px;
            color: #ffffff;
            font-size: 14px;
            padding: 9px 12px;
            box-shadow: none !important;

            &:focus {
                border-color: #ffd400;
                color: #ffd400;
            }
        }

        .custom_file_dropzone {
            border: 1px dashed $border-card;
            border-radius: 8px;
            background: #0d121a;
            padding: 24px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            cursor: pointer;
            color: $text-secondary;
            margin-bottom: 0;
            text-align: center;

            input[type="file"] {
                display: none;
            }

            i {
                font-size: 24px;
                color: inherit;
            }
            &.uploaded {
                color: #21e400;
                background-color: rgba(33, 228, 0, 0.05);
                border-color:rgba(33, 228, 0, 0.1);
            }

        }
    }

    // --- Buttons ---
    .btn-action-blue {
        background: rgba(33, 228, 0, 0.5);
        border: none;
        color: #ffffff;
        border: none;
        border-radius: 4px;
        padding: 5px 14px;
        font-size: 13px;
        font-weight: 500;

        &:hover {
            background: #ffe738;
            color: #22292f;
        }
    }

    .btn-secondary {
        background: rgba(255, 18, 18, 0.5);
        border: none;
        color: #ffffff;
        border-radius: 4px;
        padding: 5px 14px;
        font-size: 13px;
        font-weight: 500;

        &:hover {
            background: #ffe738;
            color: #22292f;
        }
    }

    .no_data_state {
        text-align: center;
        padding: 40px 20px;
        color: $text-secondary;

        .empty_icon {
            font-size: 32px;
            opacity: 0.35;
        }

        p {
            font-size: 13px;
            margin-bottom: 0;
        }
    }
}
</style>